/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';

import { InstallmentPrice } from '../../atoms/InstallmentPrice';
import { calculateNextValue } from './calculateNextValue';
import { getMaxValue } from './getMaxValue';
import { getMinValue } from './getMinValue';
import { getStepValue } from './getStepValue';

const getNextValue = calculateNextValue();

export type InstallmentPriceWithCounterProps = {
  /**
   * the currency in cents
   */
  currency: string;
  /**
   * the calculated installment value in cents
   */
  installmentValue: number;
  /**
   * is the component in loading state
   */
  isLoading: boolean;
};

/**
 * InstallmentPriceWithCounter component
 *
 * component to whether a calulated price or a loading counter will be displayed
 *
 * */
export const InstallmentPriceWithCounter = ({
  currency,
  installmentValue,
  isLoading,
}: InstallmentPriceWithCounterProps) => {
  const [value, setValue] = useState(installmentValue);
  const defaultValues = useRef({
    max: 0,
    min: 0,
    step: 0,
  });

  useEffect(() => {
    defaultValues.current = {
      max: getMaxValue(installmentValue),
      min: getMinValue(installmentValue),
      step: getStepValue(installmentValue),
    };
    setValue(installmentValue);
  }, [installmentValue]);

  useEffect(() => {
    let timeout: number | undefined;
    if (isLoading) {
      timeout = window.setTimeout(() => {
        setValue(
          getNextValue({
            current: value,
            ...defaultValues.current,
          }),
        );
      }, 50);
    } else {
      // must be set because the instalmmentValue may not change in dynamic calcluation
      // there is a monthly minimal installment and this value could always be the same
      setValue(installmentValue);
      window.clearTimeout(timeout);
    }

    return () => window.clearTimeout(timeout);
  }, [isLoading, setValue, value]);

  return <InstallmentPrice installmentValue={value} currency={currency} />;
};
